import * as Cl from '@design-system/component-library';
import { eurosPerMonthCapMsg, monthlyChargesMsg, oneTimePaymentMsg, t } from '../../common/i18n/index.js';
import { eurosToCents, formatSumToString } from '../../common/utils/priceUtils.js';
import { QuoteStatusType } from '../../generated/api/quoteStatusType.js';
import { StickyFooter } from '../StickyFooter/index.js';
import type { PriceSummaryBreakDown } from '../../generated/api/priceSummaryBreakDown.js';

import './QuoteFooterCoCo.scss';

export interface QuoteFooterProps {
  totalOneTimePrice?: PriceSummaryBreakDown;
  totalRecurringPrice?: PriceSummaryBreakDown;
  quoteStatus: QuoteStatusType;
  onAccept: () => void;
  onReject: () => void;
}

export const QuoteFooterCoCo = ({
  totalOneTimePrice,
  totalRecurringPrice,
  onAccept,
  onReject,
  quoteStatus,
}: QuoteFooterProps) => {
  const showActionButtons = quoteStatus !== QuoteStatusType.ACCEPTED && quoteStatus !== QuoteStatusType.REJECTED;
  const stickyFooterClassName = showActionButtons ? 'of-quote-footer high-mobile' : 'of-quote-footer';

  return (
    <StickyFooter active={true} className={stickyFooterClassName}>
      <Cl.Grid>
        <div className="of-quote-footer__content">
          <div className="of-quote-footer__price">
            <Cl.Price
              currentPrice={`${t.P6BC(monthlyChargesMsg)}: ${formatSumToString(eurosToCents(totalRecurringPrice?.subTotal.amount), true)}`}
              currentPriceUnit={t.H37G(eurosPerMonthCapMsg)}
              size="s"
            />
            <div className="of-quote-footer__onetime">
              {t.ASEI(oneTimePaymentMsg)}:{' '}
              <span className="of-quote-footer__onetime-value">
                {formatSumToString(eurosToCents(totalOneTimePrice?.subTotal.amount), true)} €
              </span>
            </div>
          </div>
          {showActionButtons && (
            <div className="of-quote-footer__buttons">
              <Cl.Button color="secondary" onClick={onReject} size="l">
                {t.ONSX('Reject')}
              </Cl.Button>
              <Cl.Button onClick={onAccept} size="l">
                {t.P5RQ('Accept')}
              </Cl.Button>
            </div>
          )}
        </div>
      </Cl.Grid>
    </StickyFooter>
  );
};
